export class LoadJobsEvent {
    public static readonly type = '[JobsPlacements] Load jobs event';
}
